import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import styles from './text.module.css';

const Text = ({text}) => (
  <div className={styles.text}>
    <ReactMarkdown rehypePlugins={[rehypeRaw]}>
      {text}
    </ReactMarkdown>
  </div>
);

export default Text;
